import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import { SystemSelectorComponent } from './system-selector.component';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    SystemSelectorComponent
  ],
  exports: [
      SystemSelectorComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule
  ]
})
export class SystemSelectorModule { }
